import { combineReducers } from 'redux';
import {
  SET_MEMBER_TYPE,
  SET_MEMBERS,
  SET_SELECTED_PAYER,
  FETCH_MEMBERS,
  FETCH_MEMBERS_FAILED,
  FETCH_MEMBERS_FULFILLED,
  START_TEST,
  CANCEL_TEST,
  PERFORM_CHECK,
  PERFORM_CHECK_FULFILLED,
  PERFORM_CHECK_FAILED
} from './actions';
import {
  MemberTypes,
  MemberStatuses,
  ResultStatuses
} from './constants';

import ResultUtils from './utils/ResultUtils';

function memberType(state = MemberTypes.CSV_FILE, action) {
  switch (action.type) {
    case SET_MEMBER_TYPE:
      return action.payload;
    default:
      return state;
  }
}

function memberStatus(state = null, action) {
  switch (action.type) {
    case FETCH_MEMBERS:
      return MemberStatuses.LOADING;
    case FETCH_MEMBERS_FAILED:
      return MemberStatuses.LOAD_ERROR;
    case FETCH_MEMBERS_FULFILLED:
      return MemberStatuses.LOADED;
    default:
      return state;
  }
}

function members(state = null, action) {
  switch (action.type) {
    case FETCH_MEMBERS_FULFILLED:
    case SET_MEMBERS:
      return action.payload;
    default:
      return state;
  }
}

function selectedPayer(state = null, action) {
  switch (action.type) {
  case SET_SELECTED_PAYER:
    return action.payload;
  default:
    return state;
  }
}

function globalError(state = null, action) {
  switch (action.type) {
    case PERFORM_CHECK_FAILED:
      return 'There was an unexpected error for one or more test members. ' +
        'Please reload the page and try again.';
    default:
      return state;
  }
}

function results(state = null, action) {
  switch (action.type) {
    case START_TEST:
      return action.payload;
    case CANCEL_TEST:
      return ResultUtils.cancelTestResults(state);
    case PERFORM_CHECK:
      return ResultUtils.updateTestResults(state, action.payload, ResultStatuses.LOADING);
    case PERFORM_CHECK_FULFILLED:
      return ResultUtils.updateTestResults(state, action.payload, ResultStatuses.COMPLETE);
    case PERFORM_CHECK_FAILED:
      return ResultUtils.updateTestResults(state, action.payload.request, ResultStatuses.ERROR);
    default:
      return state;
  }
}

function canceled(state = null, action) {
  switch (action.type) {
    case START_TEST:
      return false;
    case CANCEL_TEST:
      return true;
    default:
      return state;
  }
}

export default combineReducers({
  canceled,
  memberType,
  memberStatus,
  members,
  selectedPayer,
  results,
  globalError
});
